import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { Tooltip } from '@components';
import { GlobalContext } from '@contexts';
import {
  Edit2Icon,
  ExternalLinkIcon,
  MonitorIcon,
  MoreHorizontalIcon,
} from '@svgs';

import './CategoryRow.scss';

const Tag = ({ children, tooltip }) => {
  return (
    <Tooltip tooltip={tooltip}>
      <span className="sb-row-tag">{children}</span>
    </Tooltip>
  );
};

const CategoryRow = ({ category }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <div className="sb-row-item">
      <div className="sb-row--category-name">
        <p>
          <Link
            to={`/dashboard/sites/${category.site_id}/blogs/categories/${category.id}`}
          >
            {category.name}
          </Link>
        </p>
      </div>
      <div className="sb-row--category-tags">
        <p>
          {category.is_post_type && (
            <Tag tooltip="Special type of Blog category that is used only for filtering and does not display on the Blog pages">
              Post type
            </Tag>
          )}
        </p>
      </div>
    </div>
  );
};

export default CategoryRow;
